<template lang="pug">
div(class="card-container")
  el-col.card-row(:xs="24", :sm="8")
    app-card(
      title="Total de processos",
      :value="totalProcessos",
      img="NUM_PROCESSOS",
      :numericValue="true",
    )
  el-col.card-row(:xs="24", :sm="8")
    app-card(
      title="Tipo de processo com mais solicitações",
      :value="maisSolicitado.label"
      :subValue="maisSolicitado.valor"
      img="MAIS_SOLICITADO",
    )
  el-col.card-row(:xs="24", :sm="8")
    app-card(
      title="Município com mais solicitações",
      :value="municipioMaisSolicitacoes.label",
      :subValue="municipioMaisSolicitacoes.valor",
      img="MUNICIPIO",
    )
</template>

<script>
import AppCard from '@/components/AppCard'
import EnumFormatter from '@/utils/EnumFormatter'

export default {
  components: {
    AppCard
  },
  data () {
    return {
      totalProcessos: '0',
      maisSolicitado: {},
      municipioMaisSolicitacoes: {}
    }
  },
  mounted () {
    this.$store.dispatch('processos/totalProcessos').then((total) => { // eslint-disable-line
      this.totalProcessos = '' + total
    })
    this.$store.dispatch('processos/maisSolicitado').then((maisSolicitado) => { // eslint-disable-line
      this.maisSolicitado = maisSolicitado
      this.maisSolicitado.label = EnumFormatter.getTipoFormatado(maisSolicitado.label)
      this.maisSolicitado.valor = 'Total: ' + this.maisSolicitado.valor
    })
    this.$store.dispatch('processos/municipioMaisSolicitacoes').then((municipioMaisSolicitacoes) => { // eslint-disable-line
      this.municipioMaisSolicitacoes = municipioMaisSolicitacoes
      this.municipioMaisSolicitacoes.valor = 'Total: ' + this.municipioMaisSolicitacoes.valor
    })
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  justify-content: space-evenly;
}

.card-row {
  padding: 20px;
}

.card {
  width: 100% !important;
}

@media screen and (max-width: 767px) {
  .card {
    height: 150px;
    background-size: 24% !important;
  }
}

@media screen and (max-width: 550px) {
  .card {
    background-size: 37% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/home/TheDashboard.vue